import { fetchWithCredentials } from './client';

export interface CreateActivityRequest {
  phone: string;
  contactId: string;
  contactType: 'individual' | 'corporate';
  accountId?: string;
  referenceId: string;
  direction: 'INBOUND' | 'OUTBOUND';
  startDateTime?: string;
  disposition: {
    code: string;
    name: string;
    notes?: string;
  };
}

export interface CreateActivityResponse {
  success: boolean;
  data: {
    phoneCallId: string;
    displayId?: string;
    referenceId: string;
    contactId: string;
  };
}

export const activityApi = {
  async createActivity(request: CreateActivityRequest): Promise<CreateActivityResponse> {
    return fetchWithCredentials<CreateActivityResponse>('/api/v1/activity', {
      method: 'POST',
      body: JSON.stringify({ body: request }),
    });
  },
};
